export enum PreviewMode {
  MOBILE = 'mobile',
  DESKTOP = 'desktop'
}
